import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { fontSize: "xsmall" },
      style: {
        fontSize: "14px",
      },
    },
    {
      props: { fontSize: "small" },
      style: {
        fontSize: "18px",
      },
    },
    {
      props: { fontSize: "medium" },
      style: {
        fontSize: "24px",
      },
    },
    {
      props: { fontSize: "large" },
      style: {
        fontSize: "30px",
      },
    },
    {
      props: { fontSize: "xlarge" },
      style: {
        fontSize: "40px",
      },
    },
    {
      props: { fontSize: "xxlarge" },
      style: {
        fontSize: "50px",
      },
    },
    {
      props: { fontSize: "xxxlarge" },
      style: {
        fontSize: "90px",
      },
    },
    {
      props: { fontSize: "banner" },
      style: {
        fontSize: "74px",
      },
    },
    {
      props: { fontSize: "launchCardHeader" },
      style: {
        fontSize: "135px",
      },
    },
    {
      props: { fontSize: "screenPlaceholder" },
      style: {
        fontSize: "174px",
      },
    },
    {
      props: { fontSize: "sizebarNavigation" },
      style: {
        fontSize: "24px",
        fill: Colors.GREY450,
      },
    },
  ],
};
